import type { SVGProps } from "react";

export function IconPurpleDocMagnifyingGlass(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M47.8333 47.8333L51.3333 51.3333"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35 42C35 45.866 38.134 49 42 49C43.9363 49 45.6891 48.2138 46.9563 46.9432C48.2192 45.6769 49 43.9296 49 42C49 38.134 45.866 35 42 35C38.134 35 35 38.134 35 42Z"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.6666 28V13.0819C46.6666 12.9228 46.6034 12.7701 46.4909 12.6576L38.6757 4.84242C38.5631 4.7299 38.4105 4.66669 38.2514 4.66669H9.93325C9.60188 4.66669 9.33325 4.93532 9.33325 5.26669V50.7334C9.33325 51.0647 9.60188 51.3334 9.93325 51.3334H25.6666"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.3333 4.66669V13.4C37.3333 13.7314 37.6019 14 37.9333 14H46.6666"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
